module.exports = __webpack_public_path__ + "img/img-4.a8c5b65.jpg";